import classNames from 'classnames'
import type { ComponentChildren, CSSProperties, FunctionalComponent, JSX } from 'preact'
import styles from './index.module.scss'

export const Flex: FunctionalComponent<{
  inline?: boolean
  dir?: 'column' | 'row' | 'row-reverse'
  gap?: number
  align?: 'center' | 'flex-start'
  alignSelf?: 'center' | 'flex-start'
  justify?: 'center' | 'space-between' | 'start'
  class?: string
  onClick?: () => void
}> = props => {
  return (
    <div
      onClick={props.onClick}
      class={classNames(styles.root, props.class, {
        [styles.inline]: props.inline,
      })}
      style={{
        flexDirection: props.dir ?? 'column',
        gap: `${props.gap ?? 10}px`,
        alignItems: props.align,
        justifyContent: props.justify,
        alignSelf: props.alignSelf,
      }}
    >
      {props.children}
    </div>
  )
}

type ElementName = keyof JSX.IntrinsicElements

type ColOwnProps = {
  gap?: number
  gapMobile?: number
  alignItems?: 'center' | 'flex-start' | 'flex-end' | 'baseline'
  justifyContent?: 'space-between' | 'center'
  flexGrow?: number
  flexWrap?: 'wrap'
  children?: ComponentChildren
  className?: string
  style?: CSSProperties
}

type ColProps<T extends ElementName = 'div'> = ColOwnProps & {
  as?: T
  grid?: boolean
} & Omit<JSX.IntrinsicElements[T], keyof ColOwnProps | 'as'>

export function Row<T extends ElementName = 'div'>({
  as,
  gap = 0,
  gapMobile,
  alignItems,
  children,
  className,
  flexGrow,
  style,
  ...rest
}: ColProps<T>) {
  const Component = (as ?? 'div') as any

  return (
    <Component
      {...rest}
      class={classNames(styles.root, rest.class, className)}
      style={{
        '--gap-desktop': `${gap ?? 0}px`,
        '--gap-mobile': `${gapMobile ?? gap ?? 0}px`,
        alignItems,
        flexDirection: 'column',
        flexGrow,
        ...style,
      }}
    >
      {children}
    </Component>
  )
}

export function Col<T extends ElementName = 'div'>({
  as,
  gap = 0,
  gapMobile,
  alignItems,
  justifyContent,
  children,
  flexWrap,
  className,
  style,
  ...rest
}: ColProps<T>) {
  const Component = (as ?? 'div') as any

  return (
    <Component
      {...rest}
      class={classNames(styles.root, rest.class, className, {
        [styles.grid]: rest.grid,
      })}
      style={{
        '--gap-desktop': `${gap ?? 0}px`,
        '--gap-mobile': `${gapMobile ?? gap ?? 0}px`,
        alignItems,
        justifyContent,
        flexDirection: 'row',
        flexWrap,
        ...style,
      }}
    >
      {children}
    </Component>
  )
}
